export default "__VITE_ASSET__CIFqIE08__"